angular.module('DoohApps').constant('Environment', (function () {
    return {"version":"v4.1.01.1643138181","isDebugMode":false,"isTestMode":false,"restAPI":"cms.media2date.eu/DOOHappsAPI","webPlayerURL":"cms.media2date.eu/player/WebPlayer.html"};
})());